import * as Api from '@ViewModels';
import * as React from 'react';
import { useEventLogging } from '../../../models/Logging';
import { useErrorMessages } from '../../../models/hooks/appStateHooks';

export const useContactTagsUtils = (contactVm: Api.ContactViewModel) => {
	// The tagsCollection has the full tag object with color, so we use that if it exists
	const contactTags = contactVm.tagsCollection
		? contactVm.tagsCollection
		: contactVm.tags?.map(name => ({ name })) || [];

	const [tags, setTags] = React.useState<Api.IAccountTag[]>(contactTags);
	const errorMessages = useErrorMessages();
	const { logEvent } = useEventLogging('ContactInfoTags');

	const updateTags = (oldTags: Api.IAccountTag[], newTags: Api.IAccountTag[], eventName: string) => {
		const promise = contactVm.updateTags(newTags.map(({ name: tag }) => tag));
		if (promise) {
			logEvent(eventName, { count: newTags.length });
			setTags(newTags);
			promise.catch((error: Api.IOperationResultNoValue) => {
				setTags(oldTags);
				logEvent(`${eventName}-Error`, { ...error });
				errorMessages.pushApiError(error);
			});
		}
	};
	const onRequestAddTag = (accountTag: Api.IAccountTag) => {
		if (
			tags.length &&
			accountTag.name &&
			tags.find(({ name: tag }) => tag.toLocaleLowerCase() === accountTag.name.toLocaleLowerCase())
		) {
			return;
		}
		const newTags: Api.IAccountTag[] = [...tags, accountTag];
		updateTags([...tags], newTags, 'AddTag');
	};
	const onRequestRemoveTag = (accountTag: Api.IAccountTag) => {
		const newTags = [...tags];
		const index = newTags.findIndex(({ name: tag }) => tag === accountTag.name);
		if (index >= 0) {
			newTags.splice(index, 1);
			updateTags([...tags], newTags, 'RemoveTag');
		}
	};

	return { tags, onRequestAddTag, onRequestRemoveTag };
};
